import { render, staticRenderFns } from "./newgroup.vue?vue&type=template&id=6ac28f14&scoped=true&"
import script from "./newgroup.vue?vue&type=script&lang=js&"
export * from "./newgroup.vue?vue&type=script&lang=js&"
import style0 from "./newgroup.vue?vue&type=style&index=0&id=6ac28f14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac28f14",
  null
  
)

export default component.exports